import { Button } from "@shapr3d/frontend-lib";

import useNavigation from "../../hooks/navigation";
import useAccount from "../../hooks/useAccount";
import Heading from "../Heading/Heading";

import style from "./ConfirmationEduRequest.module.css";

export const ConfirmationSection = ({
  title,
  text,
  note,
}: {
  title: string;
  text?: React.ReactNode;
  note?: React.ReactNode;
}) => {
  const { goToProfile } = useNavigation();
  return (
    <section>
      <div className={style.container}>
        <Heading type="h1" className={style.title}>
          {title}
        </Heading>
        {text && <p>{text}</p>}
        <Button
          className={style.button}
          onClick={() => {
            goToProfile(["status"]);
          }}
        >
          Back to my profile
        </Button>
        {note && <div className={style.disclaimer}>{note}</div>}
      </div>
    </section>
  );
};

export enum EduConfirmationStatus {
  Requested = "requested",
  Approved = "approved",
  AlreadyRequested = "already-requested",
  AlreadyEdu = "already-edu",
  VerificationNeeded = "verification-needed",
}

interface ConfirmationEduRequestProps {
  status: EduConfirmationStatus;
}

export const ConfirmationEduRequest: React.FC<ConfirmationEduRequestProps> = ({ status }) => {
  const { data } = useAccount();

  const RequestedText = `It takes up to 3 business days to evaluate your request. If everything goes smoothly, you’ll get a confirmation email soon – otherwise, we’ll get in touch with you if there’s any info missing.`;
  switch (status) {
    case EduConfirmationStatus.Requested: {
      return <ConfirmationSection title="We got your EDU request!" text={RequestedText} />;
    }
    case EduConfirmationStatus.Approved: {
      return (
        <ConfirmationSection
          title="All set! Your EDU license is now active."
          note={
            <>
              If you already have a Pro trial running,{" "}
              <strong>you need to cancel it manually.</strong>
              <br />
              Otherwise, you&apos;ll be charged at the end of the trial regardless of your EDU
              license.
            </>
          }
        />
      );
    }
    case EduConfirmationStatus.AlreadyRequested: {
      return (
        <ConfirmationSection title="You already have a pending request" text={RequestedText} />
      );
    }
    case EduConfirmationStatus.AlreadyEdu: {
      return <ConfirmationSection title="You already have an educational license" />;
    }
    case EduConfirmationStatus.VerificationNeeded: {
      return (
        <ConfirmationSection
          title="Verify your email"
          text={
            <>
              We&apos;ve just sent an email to {data?.email}. Please check your inbox and follow the
              link in it to verify your email address.
            </>
          }
        />
      );
    }
    default: {
      return <ConfirmationSection title="Something went wrong!" />;
    }
  }
};
